angular.module('app.controllers').controller 'ApplicationCtrl', [
  '$scope', '$route', '$rootScope', 'APIFavorites', '$sce', 'APIInteractions', '$interval', '$cookies', 'APITimes', 'UI', 'APIEvent', '$location', 'APIRead', 'APIStatistics', '$timeout', '$window', '$translate', 'APICheckin'
].append (self, $route, root, APIFavorites, $sce, APIInteractions, $interval, $cookies, APITimes, UI, APIEvent, $location, APIRead, APIStatistics, $timeout, $window, $translate, APICheckin) ->
  
  self.setLang = (langKey) ->
    $translate.use(langKey)

  self.getLang = (langKey) ->
    $translate.use() == langKey

  APIRead.query {entry_type: 'campaign', full: true}, (data) ->
    self.campaignsmenu = [] #data
  , (response) ->
    UI.notify false, response.data.error

  params = $location.search()

  self.trustAsResourceUrl = $sce.trustAsResourceUrl
  
  self.trustAsHtml = (string) ->
    $sce.trustAsHtml(string)
  
  #
  # Favorites list
  #

  self.favorites = []
  self.getFavorites = () ->    
    APIFavorites.query {shortcode: root.user?.shortcode || root.tuser || 'test', tuser: root.tuser || null}, (data) ->
      self.favorites = data
  
  self.$on 'getFavorites', (event) ->
    self.getFavorites()

  self.toggleFavs = (entrycode, entry, shortcode = false) -> 
    root.activeAction = true

    # request params
    shortcode     = root.user?.shortcode || root.tuser || 'test' unless shortcode
    entrydata     = angular.copy(entry)

    exhibitor_id  = entrydata.exhibitor_id || entrydata.id
    exhibitor_id  = entrydata.exhibitor_id if entrydata.exhibitor_id == 0

    entry_id = entrydata.entry_id || entrydata.id
    entry_id = entrydata.entry_id if entrydata.entry_id == 0
          
    data = entrydata
    if entrycode in ['ex'] # no need save data for some entries becauase they saved in database
      data = {}
      entry_id = ""

    fav_code  = "#{entrycode}#{exhibitor_id}#{entry_id}"
    fav_codes = self.favorites.map((item) -> return item.fav_code)       
    fav_index = fav_codes.indexOf(fav_code)

    # remove from favorites
    if fav_index != -1
      return if entrycode in ['cr']

      (new APIFavorites).$delete {shortcode: shortcode, entrycode: entrycode, exhibitor_id: exhibitor_id, entry_id: entry_id}, () ->
        self.favorites.splice(fav_index, 1)

        if entrycode == 'ex' # exhibitors
          self.customStat(exhibitor_id, 'favorite_deleted', "Page #{entrydata.title} was deleted from favorites")

        if entrycode == 'do' # download
          exhibitor_id = null if exhibitor_id < 20
          self.customStat(exhibitor_id, 'favorite_deleted', "File #{entrydata.title} was deleted from favorites")

        if entrycode == 'li' # links
          self.customStat(exhibitor_id, 'favorite_deleted', "Link #{entrydata.title} was deleted from favorites")

        if entrycode == 'vi' # videos
          exhibitor_id = null if exhibitor_id < 20
          self.customStat(exhibitor_id, 'favorite_deleted', "Video #{entrydata.title} was deleted from favorites")

        if entrycode == 'us' # presenter users
          self.customStat(null, 'favorite_deleted', "Contact #{entrydata.name} was deleted from favorites")

        if entrycode == 'sl' # programs
          self.customStat(null, 'favorite_deleted', "Program #{entrydata.title_en || entrydata.title_de || entrydata.title} was deleted from favorites")



        self.$emit('forceFavs', entrycode, null, fav_code) if self.at('favs')
      , (errorData) -> console.debug errorData.data.error

    # save as favorites
    else

      (new APIFavorites data).$save {shortcode: shortcode, entrycode: entrycode, exhibitor_id: exhibitor_id, entry_id: entry_id}, () ->

        # track events
        if entrycode == 'ex' # exhibitors
          self.customStat(exhibitor_id, 'favorite_saved', "Page #{entrydata.title} was saved to favorites")

        if entrycode == 'do' # download
          exhibitor_id = null if exhibitor_id < 20
          self.customStat(exhibitor_id, 'favorite_saved', "File #{entrydata.title} was saved to favorites")

        if entrycode == 'li' # links
          self.customStat(exhibitor_id, 'favorite_saved', "Link #{entrydata.title} was saved to favorites")

        if entrycode == 'vi' # videos
          exhibitor_id = null if exhibitor_id < 20
          self.customStat(exhibitor_id, 'favorite_saved', "Video #{entrydata.title} was saved to favorites")

        if entrycode == 'us' # presenter users
          self.customStat(null, 'favorite_saved', "Contact #{entrydata.name} was saved to favorites")

        if entrycode == 'sl' # programs
          self.customStat(null, 'favorite_saved', "Program #{entrydata.title_en || entrydata.title_de || entrydata.title} was saved to favorites")

        if entrycode == 'cr' # contact request
          self.customStat(null, 'contact_request', entrydata.favs_themes, true, null, 'finishContactRequest')

          return


        entrydata.fav_code = fav_code
        self.favorites.push entrydata

      , (response) -> 
        UI.notify false, response.data.error

    return

  self.isFavs = (entrycode, entrydata, check = false) -> 
    return false if !entrydata?.exhibitor_id && !entrydata?.id

    exhibitor_id  = entrydata.exhibitor_id || entrydata.id
    exhibitor_id  = entrydata.exhibitor_id if entrydata.exhibitor_id == 0

    entry_id = entrydata.entry_id || entrydata.id || ""    
    if entrydata.entry_id == 0
      entry_id = entrydata.entry_id 
    else if entrydata.id == 0
      entry_id = entrydata.id 


    if entrycode in ['ex']
      entry_id = ""

    fav_code  = "#{entrycode}#{exhibitor_id}#{entry_id}"
    fav_codes = self.favorites.map((item) -> return item.fav_code)


    return fav_code in fav_codes

  self.$watch 'favorites', (newObj, oldObj) ->
    return unless newObj
  , true


  self.joinChat = (meeting, message = '', openChat = true) ->
    return unless root.xpo?
    return unless root.user?.auth_ticket?
    root.xpo.joinChat(meeting, openChat, message)

  #
  # Track events
  #
  self.$on 'sendCustomStat', (event, exhibitor_id, method, description = '') ->
    self.customStat(exhibitor_id, method, description, false)

  self.customStat = (exhibitor_id = null, method, description = '', action = true, ref_id = null, callback = false) ->
    root.activeAction = true if action

    data =
      method: method
      description: description
    
    data.exhibitor_id = exhibitor_id if exhibitor_id?
    data.ref_id = ref_id if ref_id?

    (new APIStatistics data).$save {_private: root.user?.auth_ticket, auth_ticket: root.user?.auth_ticket, page_view_id: root.pageViewId || null}, (response) ->
      self.$emit(callback) if callback
      return
    , (response) ->
      UI.notify false, response.data.error

  self.openFile = (exhibitor_id = null, file_name = '') ->
    self.customStat(exhibitor_id, 'file_open', file_name, false, false)
  
  self.openLink = (exhibitor_id = null, link_name = '') ->
    self.customStat(exhibitor_id, 'link_open', link_name, false, false)


  self.ha = () ->
    return root.session? && root.user?.auth_ticket?

  self.allowTooltip = (skip = false) ->
    return true if skip
    return false unless self.ha()
    return false if $cookies.get('s_e451_tips_hide') || $cookies.get('s_e451_tips')
    return false if self.at('auth')
    #return false if root.no_access
    return true



  self.fa = () ->
    return !$cookies.get('s_e365_theme')
  
  #
  # Slider settings
  #

  self.default3colsSlider =
    infinite: false
    arrows: false
    slidesToShow: 3
    slidesToScroll: 1
    swipeToSlide: true
    speed: 500
    autoplay: false
    autoplaySpeed: 5000
    useCSS: false
    cssEase: 'linear'
    dots: false
    dotsClass: 'slider-dots'
    customPaging : (slider, i) -> 
      return false if slider.slideCount == 1 || slider.slideCount == slider.options.slidesToShow
      return "<a class='slider-dots-item'></a>"
    responsive: [
      {
        breakpoint: 1200
        settings: 
          slidesToShow: 1
          slidesToScroll: 1
          centerMode: true
          centerPadding: '40px'
          infinite: true
      }
      {
        breakpoint: 992
        settings: 
          slidesToShow: 1
          slidesToScroll: 1
          centerMode: true
          centerPadding: '24px'
          infinite: true
      }
    ]



  self.defaultImgSlider =
    infinite: true
    arrows: true
    slidesToShow: 1
    slidesToScroll: 1
    swipeToSlide: true
    speed: 500
    fade: true
    autoplay: false
    autoplaySpeed: 5000
    useCSS: false
    cssEase: 'linear'
    dots: false
    prevArrow: '<div class="slider-control slider-control-prev"></div>'
    nextArrow: '<div class="slider-control slider-control-next"></div>'




  self.modalData = null
  self.showDataModal = (source) ->
    self.$emit 'showDataModal', source

  self.closeDataModal = () ->
    self.$emit 'closeDataModal'

  self.$on 'showDataModal', (event, source) ->
    if self.at('videos-deep')
      self.modalData = source   
    else
      if source.variab
        self[source.variab] = source
        console.log self[source.variab], source.variab
      else
        self.modalData = source   

  self.$on 'closeDataModal', (event) ->
    self.modalData = null
    self.modalData2 = null
    self.modalData23 = null

  self.linkImage = (with_image = false) ->
    return (item, index, array) ->
      return item.link_image? if with_image
      return !item.link_image unless with_image

      
  self.openContact = (email = '', name = '', favs = false) ->
    root.$broadcast 'onContactModalOpen', email, name, favs

  self.onYouTubeIframeAPIReady22 = (video_id = null, exhibitor_id = null, video_title = '', autoplay = false) ->
    return unless video_id

    $timeout () ->
      player = new YT.Player("ytPlayer#{video_id}", {
        videoId: video_id
        playerVars:
          enablejsapi: 1
          showinfo: 0
          controls: 2
          autoplay: if autoplay then 1 else 0
          origin: 'https://unlock-the-future.siemens.com'
        events:             
          'onStateChange': (event) ->
            if (event.data == YT.PlayerState.PLAYING)
              self.customStat(exhibitor_id, 'video_open', "Video #{video_title} gestartet")              
              playing = true   
            else if (event.data == YT.PlayerState.PAUSED)
              playing = false
      })
    , 5

  ###
  Profile
  ###
  $translate('modals.country.placeholder').then (trs) ->
    self.countries = [
      {
        "code": ""
        "label": trs
      }
      {
        "code": "FR"
        "label": "France"
      }
      {
        "code": "BE"
        "label": "Belgium"
      }
      {
        "code": "CH"
        "label": "Switzerland"
      }
      {
        "code": "DZ"
        "label": "Algeria"
      }
      {
        "code": "--"
        "label": "Others"
      }
    ]

  self.countryModalEl = document.getElementById('countryModal')
  if self.countryModalEl?
    self.countryModal = bootstrap.Modal.getOrCreateInstance(self.countryModalEl)

    self.countryModalEl.addEventListener('show.bs.modal', (event) ->
      self.$applyAsync()
    )
    self.countryModalEl.addEventListener('hide.bs.modal', (event) ->
      self.$applyAsync()
    )

  self.saveCountry = () ->
    self.formProccess = true
    root.session.$save {_private: true, auth_ticket: root.user?.auth_ticket}, (data) ->
      self.formProccess = false
      $translate('modals.country.thanks').then (trs) ->
        UI.notify true, trs
      self.countryModal.hide()
    , (errorData) ->
      self.formProccess = false
      UI.notify false, errorData.data.error

  self.$on 'showCountryModal', (event, source) ->
    self.countryModal.show()
    self.$applyAsync() 

  self.$on 'hideCountryModal', (event, source) ->
    self.countryModal.hide()
    self.$applyAsync()
  ###
  End profile
  ###
    


  self.videoModalEl = document.getElementById('videoModal')

  self.videoMS = false
  if self.videoModalEl?
    self.videoModal = bootstrap.Modal.getOrCreateInstance(self.videoModalEl)

    self.videoModalEl.addEventListener('shown.bs.modal', (event) ->
      # First disable and clean up any existing tracking
      self.videoMS = true
      self.$applyAsync()
    )
    self.videoModalEl.addEventListener('hidden.bs.modal', (event) ->      
      a = YT.get('qweqwe')
      a.stopVideo() if a?.g
      self.modalData = null   
      self.videoMS = false
      self.$applyAsync()
    )
    


  self.videoModalEl2 = document.getElementById('videoModal2')

  self.videoMS2 = false
  if self.videoModalEl2?
    self.videoModal = bootstrap.Modal.getOrCreateInstance(self.videoModalEl2)

    self.videoModalEl2.addEventListener('shown.bs.modal', (event) ->
      self.videoMS2 = true
      self.$applyAsync()
    )
    self.videoModalEl2.addEventListener('hidden.bs.modal', (event) ->      
      self.modalData2 = null   
      self.videoMS2 = false
      self.$applyAsync()
    )
    


  pEls = []
  for i in [0..5]
    pEls["p#{i}El"] = document.getElementById("popover-#{i}")

    pEls["p#{i}El"].addEventListener('show.bs.popover', (event) ->
      self.$broadcast "pauseVideo" if self.at('home')
      self.$applyAsync()
    )
  
  self.p0 = bootstrap.Popover.getOrCreateInstance(pEls["p0El"])

  self.showTips = () ->
    # First check if any popovers are currently displayed
    anyPopoverVisible = false
    visiblePopoverIndex = null
    for i in [0..5]
      popover = bootstrap.Popover.getOrCreateInstance(pEls["p#{i}El"])
      if popover._popper?.state?.elements?.popper?.classList.contains('show')
        anyPopoverVisible = true
        visiblePopoverIndex = i
        break

    # Enable all popovers and hide them (except first if it's visible)
    for i in [0..5]
      popover = bootstrap.Popover.getOrCreateInstance(pEls["p#{i}El"])
      popover.enable()
      if !(i == 0 && visiblePopoverIndex == 0)
        popover.hide()

    # If any popover was visible (except first), or no popovers were visible, show the first one
    if anyPopoverVisible && visiblePopoverIndex != 0 || !anyPopoverVisible
      self.p0.show()


  self.$on 'displayTips', (event, skip = false) ->
    $timeout () ->
      self.showTips() if self.allowTooltip(skip)
    , 1500


  pEls["p5El"].addEventListener('hidden.bs.popover', (event) ->
    $cookies.put('s_e451_tips', 1)
    self.$broadcast "playVideo" if self.at('home')
    self.$applyAsync()
  )

  self.nextInfo = (popover) ->
    prev = popover - 1
    next = popover
    bootstrap.Popover.getOrCreateInstance(pEls["p#{prev}El"]).hide()

    if root.no_access
      return self.nextInfo(2) if popover == 1
      return self.nextInfo(5) if popover == 4

    bootstrap.Popover.getOrCreateInstance(pEls["p#{next}El"]).show()

  self.disableInfo = (popover) ->
    $cookies.put('s_e451_tips_hide', 1)
    self.closeTips(popover)


  self.closeTips = (popover) ->
    bootstrap.Popover.getOrCreateInstance(pEls["p#{popover}El"]).hide()

    for i in [0..5]
      bootstrap.Popover.getOrCreateInstance(pEls["p#{i}El"]).disable()

    $cookies.put('s_e451_tips', 1)

    self.$broadcast "playVideo" if self.at('home')

  self.$on 'closeAllTips', (event) ->
    self.float = null
    self.floatVideo = null
    for i in [0..5]
      bootstrap.Popover.getOrCreateInstance(pEls["p#{i}El"]).hide()
      bootstrap.Popover.getOrCreateInstance(pEls["p#{i}El"]).disable()


  $window.onbeforeunload = (event) ->
    console.log 'onbeforeunload triggered'
    self.customStat(null, 'close_tab', "Close tab from #{$route.current.$$route.options.title || 'Home'} page")
    return null


  self.float = null
  self.floatVideo = null

  self.$on 'toggleFloatPlayer', (event) ->
    if self.at('programs')
      self.floatVideo = angular.copy(self.float) if self.float?
    else
      self.floatVideo = null

  self.$on "changeFloatVideo", (event, video) ->
    self.float = video

  root.$on '$destroy', () ->
    $window.onbeforeunload = undefined

  # Alert

  self.alertModalEl = document.getElementById('alertModal')
  if self.alertModalEl?
    self.alertModal = bootstrap.Modal.getOrCreateInstance(self.alertModalEl)

  self.alert = 
    closeable: false
    lastClosed: null

  ping = () ->
    APIEvent.get {_entry: 'eventdata'}, (data) ->
      # Check if closeable status changed from true to false
      wasCloseable = self.alert.closeable
      self.alert.closeable = data.alert_closeable
      
      # If changed from closeable to non-closeable, reset lastClosed
      if wasCloseable and !self.alert.closeable
        self.alert.lastClosed = null

      # Update modal config
      self.alertModal._config.backdrop = if self.alert.closeable then true else 'static'
      self.alertModal._config.keyboard = self.alert.closeable

      if data.alert_visible
        # For non-closeable alerts, show immediately
        if (!self.alert.closeable or (!self.alert.lastClosed or (Date.now() - self.alert.lastClosed) > 180000)) # 3 minutes
          self.alert.title = data.alert_title
          self.alert.text = data.alert_text
          self.alertModal.show()
      else
        self.alertModal.hide()

  # Add event listener for modal close
  if self.alertModalEl?
    self.alertModalEl.addEventListener('hidden.bs.modal', (event) ->
      if self.alert.closeable
        self.alert.lastClosed = Date.now()
    )

  ping()

  appInterval = $interval ping, 10000
